import type { IndexRouteObject, RouteObject } from "react-router-dom";
import App from "./App";
import { environment } from "./environment";
import {
  Applications,
  DeviceActivity,
  Groups,
  LinkedAccounts,
  Resources,
  SigningIn,
} from "@keycloak/keycloak-account-ui";
import { Email } from "./EmailPage";
import { PersonalInfo } from "./PersonalInfoPage";
import { DeleteAccount } from "./DeleteAccount";

export const TopRoute = {
  account: environment.baseUrl,
};

export const DeviceActivityRoute: RouteObject = {
  path: "account-security/deviceActivity",
  element: <DeviceActivity />,
};

export const LinkedAccountsRoute: RouteObject = {
  path: "account-security/linkedAccounts",
  element: <LinkedAccounts />,
};

export const SigningInRoute: RouteObject = {
  path: "account-security/signingIn",
  element: <SigningIn />,
};

export const ApplicationsRoute: RouteObject = {
  path: "applications",
  element: <Applications />,
};

export const GroupsRoute: RouteObject = {
  path: "groups",
  element: <Groups />,
};

export const ResourcesRoute: RouteObject = {
  path: "resources",
  element: <Resources />,
};

export const PersonalInfoRoute: IndexRouteObject = {
  index: true,
  path: "personal-info",
  element: <PersonalInfo />,
};

export const EmailPageRoute: RouteObject = {
  path: "email",
  element: <Email />,
};

export const DeleteAccountRoute: RouteObject = {
  path: "delete_account",
  element: <DeleteAccount />
};

export const RootRoute: RouteObject = {
  path: decodeURIComponent(new URL(environment.baseUrl).pathname),
  element: <App />,
  errorElement: <>Error</>,
  children: [
    PersonalInfoRoute,
    EmailPageRoute,
    SigningInRoute,
    DeleteAccountRoute
  ],
};

export const routes: RouteObject[] = [RootRoute];
